<template>
  <el-dialog
    :visible.sync="visible"
    title="退款确认"
    class="dialog"
    :close-on-click-modal="false"
    width="420px"
  >
    <el-form ref="form" :model="form" :rules="rules" label-suffix="：">
      <el-form-item label="入账金额（元）">
        <span>{{ form.paidAmount }}</span>
      </el-form-item>
      <el-form-item label="余额">
        <span>{{ form.useAmount }}</span>
      </el-form-item>
      <el-form-item label="参与项目占用额度">
        <span>{{ form.consumeAmount }}</span>
      </el-form-item>
      <el-form-item label="可退款金额（元）">
        <span>{{ form.remainAmount }}</span>
      </el-form-item>
      <el-form-item label="退款金额（元）" prop="refundAmount">
        <el-input-number
          v-model="form.refundAmount"
          :min="0"
          :max="999999999.99"
          :controls="false"
          :precision="2"
        />
      </el-form-item>
    </el-form>
    <div>退款到打款账号{{ info.draweeAccNo }}</div>
    <div>退款利息以最终到账的金额为准</div>
    <template v-slot:footer>
      <el-button @click="onCancel">取消</el-button>
      <el-button type="primary" @click="onConfirm">确定</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { applyGuaranteePreSaveRefundApi } from '@/api/guarantee-pre-save'
import { requiredRule } from '@/utils/form-validate'

/**
 * 退款确认弹窗
 */
export default {
  name: 'GuaranteePreSaveRefundDialog',

  data() {
    return {
      visible: false,

      info: {},
      form: {
        // 入账金额
        paidAmount: '',
        // 余额
        useAmount: '',
        // 参与项目占用额度
        consumeAmount: '',
        // 可退款金额
        remainAmount: '',
        // 退款金额
        refundAmount: undefined
      }
    }
  },

  computed: {
    rules() {
      return {
        refundAmount: [
          requiredRule('请填写退款金额'),
          {
            validator: (rule, value, callback) => {
              if (value > Number(this.info.remainAmount)) {
                callback(new Error('超出可退金额，请重新输入'))
              }
              callback()
            },
            trigger: ['change', 'blur']
          }
        ]
      }
    }
  },

  methods: {
    openDialog(info) {
      this.visible = true
      this.info = info
      this.$store
        .dispatch('finance/getGuaranteePreSaveRefundDetail', { id: info.id })
        .then(data => {
          this.form = Object.assign({}, this.form, data)
          // this.form.refundAmount = this.form.remainAmount
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },

    onConfirm() {
      this.$refs.form.validate(valid => {
        if (!valid) return

        this.$systemConfirm(`确认退款${this.form.refundAmount}元`).then(
          bool => {
            if (!bool) return
            const postData = {
              accountTransactionId: this.form.id,
              amount: this.form.refundAmount * 100
            }
            applyGuaranteePreSaveRefundApi(postData)
              .then(res => {
                this.$message.success('已申请退款')
                this.onCancel()
                this.$emit('refund')
              })
              .catch(err => {
                if (err?.message) this.$message.error(err.message)
              })
          }
        )
      })
    },

    onCancel() {
      this.visible = false
      this.$refs.form.clearValidate()
      this.$refs.form.resetFields()
    }
  }
}
</script>

<style scoped lang="scss"></style>
